<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="银企类型"
          prop="b2e_type"
          :rules="[
            {
              required: true,
              message: '请选择银企类型',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="state.model.b2e_type">
            <el-option value="boc" label="中国银行" />
            <el-option value="icbc" label="中国工商银行" />
            <el-option value="cmbc" label="中国民生银行" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="户名"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请填写户名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="银行账户"
          prop="account"
          :rules="[
            {
              required: true,
              message: '请填写银行账户',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.account"></el-input>
        </el-form-item>
        <el-form-item
          label="开户银行"
          prop="bank"
          :rules="[
            {
              required: true,
              message: '请填写开户银行',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.bank"></el-input>
        </el-form-item>
        <el-form-item
          label="开户行支行"
          prop="opening_bank"
          :rules="[
            {
              required: true,
              message: '请填写开户行支行',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.opening_bank"></el-input>
        </el-form-item>
        <el-form-item
          label="付款人手机号"
          prop="phone"
          :rules="[
            {
              required: true,
              message: '请填写付款人手机号',
              trigger: 'blur',
            },
            {
              validator: phone_rules,
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <el-form-item label="联行号">
          <el-input v-model="state.model.cnaps"></el-input>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_areacode_tree } from "@/http/data";
import {
  withholdingagent_bank_add,
  withholdingagent_bank_detail,
  withholdingagent_bank_edit,
} from "@/http/withholdingagent";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";
import { phone_rules } from "@/utils/rules";
import constant from "@/utils/constant.js";

export default {
  props: {
    id: Number,
    withholding_agent_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        service_cost_type: 0,
      },
    });
    onMounted(() => {
      onLoadAreaCode();

      if (props.id) {
        withholdingagent_bank_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;

            if (state.model.district) {
              state.model.area = [
                state.model.province,
                state.model.city,
                state.model.district,
              ];
            }
          }
        });
      }
    });

    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onAreaChange = (value) => {
      if (value.length == 3) {
        state.model.province = value[0];
        state.model.city = value[1];
        state.model.district = value[2];
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          if (props.id) {
            withholdingagent_bank_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            state.model.withholding_agent_id = props.withholding_agent_id;

            withholdingagent_bank_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      phone_rules,
      onAreaChange,
      constant,
    };
  },
};
</script>
<style scoped lang="less"></style>
